const Projectdata = [
  {
    title: "Virtual Assistant",
    type: "learning",
    subtitle: "va",
    detail:
      "🤖 A real-time Virtual Assistant web application built with React (frontend) and Node.js (backend). It allows users to interact with a smart assistant trained on user-provided information. Communication between the user and assistant is powered by Socket.io for live, bidirectional messaging. Historical chat data—whether from yesterday or months ago—is stored securely and retrieved using the Gemini LLM for intelligent, context-aware responses. All user and chat data is persistently stored using a MongoDB server, ensuring reliability and scalability. The app features a clean UI, responsive design, and efficient state handling.",
    sourcelink: "",
    livelink: "https://virtual-assistant-ochre.vercel.app", // Replace with actual live link
    technology: [
      "react",
      "RTK",
      "React Bootstrap",
      "css",
      "html",
      "node",
      "MongoDB",
      "render server",
    ],
  },
  {
    title: "InstaChat",
    type: "learning",
    subtitle: "instachat",
    detail:
      "💻 A modern and feature-rich real-time chat application, InstaChat combines the power of Node.js for backend functionality with Cloudinary for seamless image storage and retrieval. Leveraging WebSockets for instant messaging, this app delivers a fast, responsive, and interactive chatting experience. Fully responsive and elegantly designed, InstaChat ensures smooth communication across devices, empowering users to connect and share in real time. 📱",
    sourcelink: "",
    livelink: "https://insta-chat-lemon.vercel.app",
    technology: [
      "react",
      "node",
      "socket.io",
      "Cloudinary",
      "React Bootstrap",
      "css",
      "html",
    ],
  },
  {
    title: "Money Tracker",
    type: "learning",
    subtitle: "et",
    detail:
      "💻 A fully responsive Money Tracker app that I developed, featuring user authentication, dynamic dashboards, transaction filters, and a built-in to-do list. It includes full CRUD operations and is built with React, RTK, and ApexCharts, providing real-time insights with secure data storage in MongoDB, and deployment on Render.com. 📱",
    sourcelink: "",
    livelink: "https://money-tracker-beige-two.vercel.app",
    technology: [
      "react",
      "RTK",
      "React Bootstrap",
      "css",
      "html",
      "node",
      "MongoDB",
      "render server",
      "Apexcharts",
    ],
  },
  {
    title: "Event Management System",
    type: "learning",
    subtitle: "ems",
    detail:
      "💻 A React-based Event Management System utilizing Redux Toolkit and Chart.js for efficient event tracking. Real-time Google Maps integration ensures accurate location tracking, while a mobile-responsive design provides seamless access across devices. 📱",
    sourcelink: "",
    livelink: "https://pekskumar.github.io/ems-react",
    technology: [
      "react",
      "RTK",
      "React Bootstrap",
      "css",
      "html",
      "ipapi.co",
      "openweathermap",
      "Chart.js",
    ],
  },
  {
    title: "Life Cart Store",
    type: "learning",
    subtitle: "cart",
    detail:
      "💻 A mobile-responsive online store with advanced filtering options, built using React, RTK, and Chart.js. Features secure online payments via a Node.js API deployed on Render.com, seamlessly integrated with Stripe. 📱",
    sourcelink: "https://github.com/Pekskumar/cart-react",
    livelink: "https://pekskumar.github.io/cart-react/",
    technology: [
      "react",
      "RTK",
      "React Bootstrap",
      "css",
      "html",
      "dummyjson API",
      "node",
      "stripe",
      "render server",
      "Chart.js",
    ],
  },

  {
    title: "Gmail Clone",
    type: "learning",
    subtitle: "gc",
    detail:
      "💻 A meticulously designed Gmail clone that mirrors the Google Mail interface, offering a seamless and intuitive email experience. Utilizing the react-oauth/google package, this project fetches real-time email data, ensuring users have up-to-date information at their fingertips.",
    sourcelink: "",
    livelink: "https://pekskumar.github.io/gmail-react",
    technology: ["react", "RTK", "React Bootstrap", "css", "html"],
  },
  {
    title: "Microsoft Clone",
    type: "learning",
    subtitle: "mc",
    detail:
      "💻 A meticulously crafted Microsoft clone that faithfully replicates the Microsoft interface, delivering a smooth and familiar user experience. This project utilizes the @azure/msal-react package to fetch real-time email data from Microsoft, ensuring users have access to the latest information effortlessly.",
    sourcelink: "",
    livelink: "https://pekskumar.github.io/microsoft-react",
    technology: ["react", "RTK", "React Bootstrap", "css", "html"],
  },
  {
    title: "Google Analytic",
    type: "learning",
    subtitle: "ga-4",
    detail:
      "💻 A comprehensive and fully mobile-responsive Google Analytic project that aggregates and displays extensive user traffic data from various live websites. Featuring a Node.js backend API deployed on Render.com, this project gathers data on user locations, device types, new vs. returning visitors, event counts, and more. The data is visualized through detailed charts on a React-powered interface, offering insights into user behavior, landing pages, top referring sites, and screen resolutions, all seamlessly grouped and presented for easy analysis. 📱",
    sourcelink: "",
    livelink: "https://pekskumar.github.io/google-analytic",
    technology: [
      "react",
      "RTK",
      "React Bootstrap",
      "css",
      "html",
      "node",
      "render server",
      "Chart.js",
    ],
  },
  {
    title: "Google Search Engine",
    type: "learning",
    subtitle: "gse",
    detail:
      "💻 A dynamic and fully responsive Google Search Engine project that leverages the Google Custom Search API to deliver precise and efficient search results. Designed with a clean and intuitive interface, this project provides a seamless search experience, mirroring the functionality and ease of use found in Google's own search platform. 📱",
    sourcelink: "",
    livelink: "https://pekskumar.github.io/google-search-engine",
    technology: ["react", "RTK", "React Bootstrap", "css", "html"],
  },
  // {
  //   title: "Task Board",
  //   type: "learning",
  //   subtitle: "taskboard",
  //   detail:
  //     "💻 A sleek Task Board application that leverages local storage for task management. This project features custom drag-and-drop functionality, allowing users to effortlessly move tasks between stages like 'To Do,' 'In Progress,' 'In Review,' and 'Done.' With robust CRUD operations for modifying and deleting tasks, it provides a streamlined and interactive experience for managing workflows.",
  //   sourcelink: "",
  //   livelink: "https://pekskumar.github.io/TaskBoard",
  //   technology: ["react", "RTK", "React Bootstrap", "css", "html"],
  // },
  {
    title: "NEWS",
    type: "learning",
    subtitle: "news",
    detail:
      "💻 A dynamic and fully responsive news application that combines real-time data and intuitive design. Using the ipapi.co API, it fetches live location data to display traffic insights on Google Maps. The project also integrates OpenWeatherMap for live weather updates and gnews.io to deliver categorized news from India, covering topics like general,entertainment, sports, technology,business,science and health.",
    sourcelink: "",
    livelink: "https://pekskumar.github.io/news-react",
    technology: [
      "react",
      "React Bootstrap",
      "css",
      "gnews.io",
      "ipapi.co",
      "openweathermap",
      "html",
    ],
  },
  
  {
    title: "Super MIA",
    type: "official",
    subtitle: "",
    detail:
      "🤖 Super MIA is a scalable AI platform for building and deploying multi-LLM powered chat and voice agents. It supports dynamic model orchestration across different foundation models and enables real-time conversational streaming using LiveKit. The system allows businesses to create customizable AI assistants for automation, customer support, and interactive workflows with low-latency voice and text communication. 🚀💬",
    sourcelink: "",
    livelink: "",
    technology: [
      "React",
      "Redux Toolkit",
      "Node.js",
      "Python",
      "LiveKit",
      "LLM APIs",
      "REST APIs",
      "WebSockets",
    ],
  },
  {
    title: "Forever Roses",
    type: "official",
    subtitle: "",
    detail:
      "🌹 Forever Roses is an innovative QR code gifting platform that allows users to share recorded video messages through unique QR codes. Built with React and Redux Toolkit, this application ensures a seamless and engaging gifting experience. The integration of React Bootstrap enhances the UI, providing a modern and responsive design. Perfect for personalized gifts, Forever Roses lets users create meaningful and memorable video messages for their loved ones. 🎥📲",
    sourcelink: "",
    livelink: "",
    // livelink: "https://4everroses.vercel.app/4YQVN63LRK7MUA8FCES5",
    technology: ["react", "React Bootstrap", "css", "html"],
  },

  {
    title: "Quantum Datalitica",
    type: "official",
    subtitle: "",
    detail:
      "⚡ Quantum Datalitica is a high-performance data management platform that enables users to efficiently process large-scale data based on customized machine configurations. Users can create machines, define workflows by entering machine parameters, and obtain real-time output from these workflows. The platform supports multiple user roles, including subscribers, contacts, developers, and organizers. Additionally, users can invite others, create their own machines, and engage in the Quantum Datalitica community center by liking and commenting on various posts. 🚀🔬",
    sourcelink: "",
    livelink: "",
    // livelink: "https://beta-dev.quantumdatalytica.com/",
    technology: ["react", "RTK", "React Bootstrap", "css", "html"],
  },
  {
    title: "M&M (Guard Monitor & Manage)",
    type: "official",
    subtitle: "",
    detail:
      "🛡️ M&M is a cutting-edge security guard management platform that offers real-time monitoring and patrolling solutions. Designed for security service providers and property management, M&M connects guards with management to streamline operations. With powerful features such as live tracking, perimeter security monitoring, guard scheduling, and data logs, M&M enhances operational efficiency and workforce accountability. This intuitive system ensures a seamless guard tour experience with low fees and high-quality features, redefining security service management. 🔒📍",
    sourcelink: "",
    // livelink: "https://monitormanage.com.my/",
    livelink: "",
    technology: ["react", "RTK", "React Bootstrap", "css", "html"],
  },

  {
    title: "Pickleball",
    type: "official",
    subtitle: "",
    detail:
      "🏓 Pickleball is a global court booking platform where users can register, select a membership plan (Premium, Classic, or Standard), and book courts for rent based on a time schedule. The platform integrates Stripe for secure worldwide payment processing. Additionally, users—including coaches and players—can post images, videos, and scores while engaging through likes, comments, and ratings. Pickleball fosters a dynamic international sports community, ensuring seamless court reservations and player interactions. 🌍🎾🔥",
    sourcelink: "",
    livelink: "",
    // livelink: "https://app.picklerclubs.com/",
    technology: ["react", "RTK", "stripe", "React Bootstrap", "css", "html"],
  },
  {
    title: "Intelligent CRM",
    type: "official",
    subtitle: "",
    detail:
      "📊 Intelligent CRM is a powerful customer relationship management platform designed specifically for hotels to drive revenue growth. It helps hotels optimize sales strategies with features like sales funnel organization, lead prioritization, productivity tracking, and integrated marketing planning. The platform provides real-time reporting, revenue tracking, and actionable insights to ensure hotels maximize their sales potential. With Intelligent CRM, hotels can streamline operations, enhance customer engagement, and achieve long-term business success. 🏨💼📈",
    sourcelink: "",
    livelink: "",
    // livelink: "https://inntelligentcrm.com/",
    technology: ["react", "RTK", "React Bootstrap", "css", "html"],
  },
  {
    title: "Fenced",
    type: "official",
    subtitle: "",
    detail:
      "🏨 Fenced is a comprehensive hospitality management system designed for hotels. This platform streamlines hotel operations, including room bookings, rental management, and other essential services. With a user-friendly interface and seamless functionality, Fenced enhances the efficiency of hotel administration, ensuring a smooth experience for both hotel managers and guests. 🏢✨",
    sourcelink: "",
    livelink: "",
    technology: ["react", "RTK", "React Bootstrap", "css", "html"],
  },
  {
    title: "OMS (Online Management System)",
    type: "official",
    subtitle: "",
    detail:
      "📊 OMS is a comprehensive Online Management System designed to streamline company operations. This platform integrates task creation, project management, leave applications, and other essential workplace functionalities into a single, user-friendly interface. Built with robust technologies, OMS ensures efficiency, transparency, and seamless collaboration among team members. 🚀",
    sourcelink: "",
    livelink: "",
    // livelink: "https://office.softqubes.com/",
    technology: ["react", "RTK", "React Bootstrap", "sass", "html"],
  },
];

export default Projectdata;
